import React, { useEffect } from 'react';
import { RankingContext } from '@/context/ranking';
import { VariationCard } from '../../molecules/AreaVariation/Card';
import { Container, WrapperCard, TitleSection, WrapperContent } from './styles';

export const AreaVariation: React.FC = () => {
  const { RakingData, researchArea } = React.useContext(RankingContext);
  return (
    <Container>
      <WrapperContent>
        {researchArea !== 'Geral' &&
          <TitleSection>Destaques das melhores e piores variações na área</TitleSection>
        }
        {researchArea === 'Geral' &&
          <TitleSection>Destaques das melhores e piores variações</TitleSection>
        }
        <WrapperCard>
          <VariationCard title="Posição no ranking do IDGE" name="posicao" data={RakingData[researchArea]?.destaques?.posicao} />
          <VariationCard title="Indicador do IDGE" name='indicador' data={RakingData[researchArea]?.destaques?.indicador} />
        </WrapperCard>
      </WrapperContent>
    </Container>
  );
};
